import React, { useEffect, useState } from "react";
import { useOrganization } from "../../configurations/OrganizationContext";
import { helperServices } from "../../shared/helper";
import {DIRECTOR_ROLE} from "../../shared/constants";
import DownloadReportActions from "./DownloadReport";

function MyReports() {
  const org = useOrganization();
  const tabs = org?.tabs || {}; 
  const tabKeys = Object.keys(tabs);
  const [activeTab, setActiveTab] = useState(tabKeys[0] || "");
  const currentUserRole = helperServices.getRole();

  const visibleTabKeys = tabKeys.filter(key => {
      const role = tabs[key]?.role || "ALL";

      if (currentUserRole === DIRECTOR_ROLE) {
        // Director sees only director tabs
        return role === "Director";
      }
      // Non-director sees only normal tabs
      return role === "ALL";
    });
    {console.log("visibleTabKeys",visibleTabKeys)}


  // Update active tab when org changes (e.g., async load)
  useEffect(() => {
    if (visibleTabKeys.length > 0) {
      setActiveTab(visibleTabKeys[0]);
    }
  }, [org]);

  // ✅ Handle no tabs
  if (!org) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <strong>Loading organization data...</strong>
      </div>
    );
  }

  if (!tabKeys.length) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <strong>No reports available</strong>
      </div>
    );
  }

  // const filteredTabKeys = tabKeys.filter(key => key !== "directorDashboard");

  // const visibleTabKeys = (currentUserRole === DIRECTOR_ROLE)
  //     ? ["directorDashboard"]        
  //     : filteredTabKeys;  




  return (
    <div>
      {/* Dynamic nav */}
      <ul className="nav nav-tabs nav-fill">
        {visibleTabKeys.map((key) => (
          <li className="nav-item" key={key}>
            <button
              className={`nav-link ${activeTab === key ? "active" : ""}`}
              onClick={() => setActiveTab(key)}
            >
              {tabs[key]?.label || key}
            </button>
          </li>
        ))}
      </ul>

         {/* Content */}
    <div className="mt-3">
      {/* IFRAME */}
      {tabs[activeTab]?.type === "iframe" && (
        <iframe
          src={`${process.env.REACT_APP_EVN_HOST}${tabs[activeTab]?.url}`}
          frameBorder="0"
          width="100%"
          height="600"
          title={tabs[activeTab]?.label}
        />
      )}

      {/* CUSTOM COMPONENT */}
      {tabs[activeTab]?.type === "component" && (
        <DownloadReportActions />
      )}

      {/* FALLBACK */}
      {!tabs[activeTab]?.type && (
        <div style={{ padding: 20, textAlign: "center" }}>
          <strong>Coming Soon...</strong>
        </div>
      )}
    </div>

      {/* Dynamic iframe */}
      {/* <div>
        {tabs[activeTab]?.url ? (
          <iframe
            src={`${process.env.REACT_APP_EVN_HOST}${tabs[activeTab].url}`}
            frameBorder="0"
            width="100%"
            height="600"
            allowTransparency="true"
            title={tabs[activeTab].label || "Report"}
          ></iframe>
        ) : (
          
            <DownloadReportActions />
        
        )}
      </div> */}
    </div>
  );
}

export default MyReports;
